import { render } from "./FooterArea.vue?vue&type=template&id=0caebd0c"
import script from "./FooterArea.vue?vue&type=script&lang=js"
export * from "./FooterArea.vue?vue&type=script&lang=js"

import "./FooterArea.vue?vue&type=style&index=0&id=0caebd0c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__